import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import logohdf from '../images/logohdf.jpg';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navItems = [
    { text: 'Home', path: '/' },
    { text: 'Services', path: '/services' },
    { text: 'Privacy', path: '/privacy' },
  ];

  const drawer = (
    <Box sx={{ width: 250 }} role="presentation" onClick={handleDrawerToggle}>
      <List>
        {navItems.map((item) => (
          <ListItem
            button
            key={item.text}
            component={Link as React.ElementType}
            to={item.path}
          >
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      {/* AppBar for Desktop and Mobile */}
      <AppBar 
        position="static"
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #ff0000 0%, #cc0000 100%)',
          borderBottom: '2px solid rgba(255,255,255,0.1)',
          backdropFilter: 'blur(10px)',
        }}
      >
        <Toolbar sx={{ py: 1 }}>
          {/* Logo and Title */}
          <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
            <Box
              sx={{
                width: 50,
                height: 50,
                borderRadius: '8px',
                overflow: 'hidden',
                mr: 2,
                border: '2px solid rgba(255,255,255,0.2)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
              }}
            >
              <img
                src={logohdf}
                alt="HDF Hauling Logo"
                style={{ 
                  width: '100%', 
                  height: '100%', 
                  objectFit: 'cover' 
                }}
              />
            </Box>
            <Typography 
              variant="h5" 
              component="div" 
              sx={{ 
                color: 'white',
                fontWeight: 800,
                fontSize: { xs: '1.3rem', md: '1.5rem' },
                textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                letterSpacing: '0.5px',
              }}
            >
              HDF Hauling
            </Typography>
          </Box>

          {/* Full Menu for Desktop */}
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            {navItems.map((item) => (
              <Button
                key={item.text}
                component={Link}
                to={item.path}
                sx={{
                  color: 'white',
                  mx: 1,
                  px: 3,
                  py: 1,
                  fontSize: '1rem',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '1px',
                  borderRadius: 2,
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.15)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                  },
                  '&:before': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 0,
                    height: '2px',
                    backgroundColor: 'white',
                    transition: 'width 0.3s ease',
                  },
                  '&:hover:before': {
                    width: '80%',
                  },
                }}
              >
                {item.text}
              </Button>
            ))}
          </Box>

          {/* Hamburger Menu Icon for Mobile */}
          <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
            <IconButton 
              color="inherit" 
              edge="end" 
              onClick={handleDrawerToggle}
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.15)',
                },
              }}
            >
              <MenuIcon sx={{ fontSize: '1.8rem' }} />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer for Mobile Menu */}
      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        PaperProps={{
          sx: {
            background: 'linear-gradient(135deg, #ff0000 0%, #cc0000 100%)',
            color: 'white',
            width: 280,
          },
        }}
      >
        <Box sx={{ width: 280, pt: 2 }} role="presentation" onClick={handleDrawerToggle}>
          {/* Mobile Menu Header */}
          <Box sx={{ px: 3, pb: 2, borderBottom: '1px solid rgba(255,255,255,0.2)' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: '6px',
                  overflow: 'hidden',
                  mr: 2,
                  border: '1px solid rgba(255,255,255,0.3)',
                }}
              >
                <img
                  src={logohdf}
                  alt="HDF Hauling Logo"
                  style={{ 
                    width: '100%', 
                    height: '100%', 
                    objectFit: 'cover' 
                  }}
                />
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                HDF Hauling
              </Typography>
            </Box>
          </Box>
          
          <List sx={{ pt: 2 }}>
            {navItems.map((item) => (
              <ListItem
                button
                key={item.text}
                component={Link as React.ElementType}
                to={item.path}
                sx={{
                  py: 2,
                  px: 3,
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.15)',
                  },
                }}
              >
                <ListItemText 
                  primary={item.text}
                  primaryTypographyProps={{
                    fontWeight: 600,
                    fontSize: '1.1rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default Navbar;
